import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Brush,
} from "recharts";
import { useMediaQuery } from "react-responsive";
import { ChartWrapper } from "../components/ChartWrapper";
import { formatLabel } from "../../utils/string";

const renderSmartLabel = (data, key) => (props) => {
  const { x, y, width, height, index } = props;

  const actualValue = data?.[index]?.[key];

  if (!actualValue || actualValue === 0) return null;

  // Small bar → show above
  if (height < 18) {
    return (
      <text
        x={x + width / 2}
        y={y - 4}
        fill="#111"
        textAnchor="middle"
        fontSize={11}
        fontWeight="600"
      >
        {actualValue}%
      </text>
    );
  }

  // Normal → inside
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={11}
      fontWeight="700"
    >
      {actualValue}%
    </text>
  );
};
export default function LearningStrength({ data = [], loading }) {
  const isSmall = useMediaQuery({ query: "(max-width: 600px)" });

  return (
    <ChartWrapper
      loading={loading}
      title={"Learning Strength & Gap"}
      subtitle={"Resource-wise performance overview"}
      isEmpty={!Boolean(data?.length)}
    >
      <ResponsiveContainer width="100%" height={"100%"}>
        
        <BarChart
          data={data}
          barCategoryGap={isSmall ? "15%" : "20%"}
          margin={{
            top: 30,
            right: 20,
            left: 20,
            bottom: 50,
          }}
        >
          <Legend
            wrapperStyle={{
              fontSize: "16px",
              fontWeight: 600,
              paddingTop: 10,
            }}
          />
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

          <XAxis
            tickFormatter={value => formatLabel(value)}
            dataKey="Subject"
            interval={0}
            tick={{
              fontSize: isSmall ? 12 : 15,
              fill: "#222",
              fontWeight: 600,
            }}
            axisLine={{ stroke: "#999", strokeWidth: 1.2 }}
            tickLine={false}
            angle={isSmall ? -25 : 0}
            textAnchor={isSmall ? "end" : "middle"}
          />
          <Brush
            dataKey="Subject"
            height={10}
            endIndex={
              data.length > 0 ? Math.min(Math.abs(data.length - 1), 4) : 1
            }
              stroke="#94a3b8"
          />
          <YAxis
            tick={{
              fontSize: 12,
              fill: "#222",
              fontWeight: 600,
            }}
            axisLine={{ stroke: "#999", strokeWidth: 1.2 }}
            tickLine={false}
            width={40}
            label={{
              value: "Score (%)",
              angle: -90,
              position: "insideLeft",
              style: {
                textAnchor: "middle",
                fontSize: 13,
                fontWeight: 700,
                fill: "#111",
              },
            }}
          />
          <Tooltip
            contentStyle={{
              borderRadius: "10px",
              border: "none",
              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
              fontSize: "13px",
            }}
            formatter={(value, name) => [`${value}%`, name]}
          />
         

          <Bar dataKey="Strength" stackId="a" fill="#06b6d4" maxBarSize={45}>
            <LabelList content={renderSmartLabel(data, "Strength")} />
          </Bar>

          <Bar dataKey="Gap" stackId="a" fill="#ef4444" maxBarSize={45}>
            <LabelList content={renderSmartLabel(data, "Gap")} />
          </Bar>

          
        </BarChart>
         
      </ResponsiveContainer>
    </ChartWrapper>
  );
}
